import {combineReducers} from 'redux';
import UserSession from '../reducers/session';
import SourceMode from '../reducers/mode';
import CommonData from '../reducers/commonData';
import EnvStateData from '../reducers/environmentStateSlice';

const reducers = {
    UserSession,
    SourceMode,
    CommonData,
    EnvStateData
};

export default combineReducers({...reducers});
